export default __webpack_public_path__ + "static/media/minimal.62551991.png";